<template>
  <div class="wrongQuestion question-img">
    <div class="top-list">
      <p class="top-item">共{{ total }}题</p>
      <p class="ts text-box" style="max-width: 25%" @click="examPicker = true">
        {{ examVal }}
      </p>
      <div class="top-item" @click="scorePicker = true">
        <p class="text-box">得分率{{ scoreVal }}</p>
        <van-icon name="arrow-down" size="16" />
      </div>
      <div class="top-item" @click="questionPicker = true">
        <p class="text-box">{{ questionVal }}</p>
        <van-icon name="arrow-down" size="16" />
      </div>
    </div>
    <div
      v-for="(v, i) in questionListData"
      :key="i"
      class="question-list"
      @click="toDetail(v)"
    >
      <div class="html-class" v-html="v.question"></div>
    </div>
    <div class="loading-box">
      <van-loading v-if="current < pages" size="24px">加载中...</van-loading>
      <van-divider v-else dashed>没有找到更多了</van-divider>
    </div>
    <!-- 考试弹窗 -->
    <van-popup v-model="examPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="examList"
        @cancel="examPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 题型弹窗 -->
    <van-popup v-model="questionPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="questionType"
        @cancel="questionPicker = false"
        @confirm="questionConfirm"
      />
    </van-popup>
    <!-- 得分率弹框 -->
    <van-popup v-model="scorePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="scoreList"
        @cancel="scorePicker = false"
        @confirm="scoreConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
const listWrong = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
import { questionInfo, questionPage, getExamList } from "@/api/interface";
export default {
  name: "WrongQuestion",
  props: { searchData: Object },
  data() {
    return {
      questionData: {},
      // examDataList: [],
      examList: ["全部考试"],
      examVal: "全部考试",
      examPicker: false,
      questionType: ["全部题型"],
      questionVal: "全部题型",
      questionPicker: false,
      current: 0,
      pages: 2,
      total: 0,
      scoreList: [
        // 第一列
        {
          values: listWrong,
          defaultIndex: 0,
        },
        // 第二列
        {
          values: listWrong,
          defaultIndex: 9,
        },
      ],
      scoreVal: "0.2~0.8",
      scorePicker: false,
      questionListData: [],
    };
  },
  watch: {
    examVal() {
      this.current = 1;
      this.questionList();
    },
    questionVal() {
      this.current = 1;
      this.questionList();
    },
    scoreVal() {
      this.current = 1;
      this.questionList();
    },
  },
  created() {
    this.current = 1;
    this.getOption();
    this.questionList();
    this.getExamList();
  },
  mounted() {
    // window.addEventListener("scroll", this.disposeScroll); //监听滚动条
  },
  beforeDestroy() {
    //离开
    window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
  },
  methods: {
    getExamList() {
      getExamList(this.searchData).then((res) => {
        this.examListData = res.data;
        this.examListData.forEach((item) => {
          this.examList.push(item.examName);
        });
      });
    },
    disposeScroll() {
      if (this.current == this.page) {
        return;
      } // 如果当前大于总页数，也就是最后一页，那么就不不触发了
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0; // 获取滚动条垂直的位置
      if (document.body.clientHeight - top - window.innerHeight < 20) {
        this.current++;
        this.questionList();
        //如果滚动条的位置加上窗口的高度大于可见的窗口可见的高度，那么也就是滚动条到低了
        // this.$emit('update') // 执行update方法
      }
    },
    toDetail(val) {
      this.$store.commit("setWorngData", val);
      // let data = {};
      // if (this.$route.query.studentId) {
      //   data.studentId = this.$route.query.studentId;
      // }
      this.$router.push({
        name: "ShowQuestion",
        query: this.$route.query,
      });
    },
    scoreConfirm(value) {
      this.scoreVal = value[0] + "~" + value[1];
      this.scorePicker = false;
      this.current = 1;
      this.pages = 2;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.questionList();
    },
    onConfirm(value) {
      this.examVal = value;
      this.examPicker = false;
      this.current = 1;
      this.pages = 2;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.questionList();
    },
    questionConfirm(value) {
      this.questionVal = value;
      this.questionPicker = false;
      this.current = 1;
      this.pages = 2;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.questionList();
    },
    getOption() {
      questionInfo(this.searchData).then((res) => {
        this.questionData = res.data;

        res.data.questionTypeList.forEach((item) => {
          this.questionType.push(item.questionType);
        });
      });
    },
    questionList() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      data.current = this.current;
      data.size = 14;
      //考试题型；
      if (this.questionVal != "全部题型") {
        data.quesType = this.questionVal;
      }
      if (this.examVal == "全部考试") {
        data.examPaperIds = "";
      } else {
        data.examPaperIds = this.examListData.filter(
          (i) => i.examName == this.examVal
        )[0].examPaperId;
      }
      let arr = this.scoreVal.split("~");
      data.scoreRateMin = arr[0];
      data.scoreRateMax = arr[1];
      questionPage(data).then((res) => {
        this.current = res.data.current;
        this.pages = res.data.pages;
        this.total = res.data.total;
        if (this.current == 1) {
          // this.aa = res.data;
          // this.query = data;

          this.questionListData = res.data.records;
          window.addEventListener("scroll", this.disposeScroll); //监听滚动条
        } else {
          this.questionListData = this.questionListData.concat(
            res.data.records
          );
          // console.log(this.knowledList);
        }
        // this.questionListData = res.data.records;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.wrongQuestion {
  padding: 0 12px;
  .html-class {
    height: 44px;
    overflow: hidden;
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // line-clamp: 2;
    // -webkit-box-orient: vertical;
  }
  .loading-box {
    text-align: center;
  }
  .question-list {
    padding: 12px 16px;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .top-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .top-item {
      padding: 26px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .van-icon {
        margin-left: 6px;
      }
    }
    .text-box {
      max-width: 85%;
      overflow: hidden;
      //当文本溢出，省略号代替
      text-overflow: ellipsis;
      //文本不会换行，文本会在在同一行上继续，直到遇到 <br> 标签为止。
      white-space: nowrap;
    }
    .ts {
      color: #7b9cc7;
    }
  }
}
</style>
